import React from 'react';
import { useHistory } from 'react-router-dom';

import TransactionPresenter from '../../../../../../../../presenters/TransactionPresenter';
import BankAccountPresenter, {
  DUPLICATE_STATES,
} from '../../../../../../../../presenters/BankAccountPresenter';
import appRoutes from '../../../../../../../../routes/appRoutes';
import { ElementLink } from '../../../../../../../../components';

const Transaction = (props) => {
  const { transaction, previousTransaction } = props;
  const isFirstDateFromGroup =
    TransactionPresenter.date(transaction) !==
    TransactionPresenter.date(previousTransaction);

  const history = useHistory();

  const handleRedirectToCashback = (e) => {
    e.stopPropagation();

    const path = appRoutes.cashbackPath(
      TransactionPresenter.cashbackId(transaction)
    );
    history.push(path);
  };

  const bankAccount = TransactionPresenter.bankAccount(transaction);
  const isDuplicate = DUPLICATE_STATES.includes(
    BankAccountPresenter.duplicationStateReadable(bankAccount)
  );

  return (
    <React.Fragment>
      {isFirstDateFromGroup && (
        <tr className="date-group-title">
          <td colSpan="8">{TransactionPresenter.date(transaction)}</td>
        </tr>
      )}
      <ElementLink
        element="tr"
        to={appRoutes.transactionPath(TransactionPresenter.id(transaction))}
        className="transaction-cell"
      >
        <td>{TransactionPresenter.date(transaction)}</td>
        <td>
          {TransactionPresenter.name(transaction)}
          {isDuplicate && <div className="label-removed">Duplicate</div>}
        </td>
        <td>{TransactionPresenter.storeName(transaction)}</td>
        <td>{TransactionPresenter.location(transaction)}</td>
        <td>{TransactionPresenter.merchantName(transaction)}</td>
        <td>{TransactionPresenter.amountReadable(transaction)}</td>
        <td>{TransactionPresenter.status(transaction)}</td>
        <td>
          {TransactionPresenter.isTransactionWithCashback(transaction) ? (
            <button
              className="nav-button"
              onClick={handleRedirectToCashback}
              role="link"
            >
              {TransactionPresenter.displayedCashbackRate(transaction)}
            </button>
          ) : (
            <span>--</span>
          )}
        </td>
      </ElementLink>
    </React.Fragment>
  );
};

Transaction.propTypes = {
  transaction: TransactionPresenter.shape().isRequired,
  previousTransaction: TransactionPresenter.shape(),
};

Transaction.defaultProps = {
  previousTransaction: null,
};

export default Transaction;
